import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION } from '../utils'
import EmptyStar from '../assets/EmptyStar'
import FullStar from '../assets/FullStar'
import HalfStar from '../assets/HalfStar'
import { HideOnHover, Rating, Review, ShowOnHover } from './styles'

interface StarRatingProps {
  rating?: number
  reviewCount?: number
  maxStars?: number
  precision?: number
}

export const DotIcon = () => {
  return (
    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.42 4.074C1.964 4.074 1.57767 3.922 1.261 3.618C0.944333 3.30133 0.786 2.90867 0.786 2.44C0.786 1.97133 0.944333 1.585 1.261 1.281C1.57767 0.964333 1.964 0.806 2.42 0.806C2.876 0.806 3.26233 0.964333 3.579 1.281C3.89567 1.585 4.054 1.97133 4.054 2.44C4.054 2.90867 3.89567 3.30133 3.579 3.618C3.26233 3.922 2.876 4.074 2.42 4.074Z"
        fill="#9FA6BB"
      />
    </svg>
  )
}

export const StarRating = ({
  rating,
  reviewCount,
  maxStars = 5,
  precision = 0.5,
}: StarRatingProps) => {
  const { i18n } = useI18n()
  if (!rating || !reviewCount) {
    return null
  }

  const normalized = Math.round(rating / precision) * precision

  const stars = Array.from({ length: maxStars }, (_, i) => {
    const lower = i
    const upper = i + 1
    if (normalized >= upper) {
      return 1
    } else if (normalized <= lower) {
      return 0
    } else {
      return normalized - lower
    }
  })

  return (
    <Rating data-testid="course-rating">
      <div className="stars">
        {stars.map((fill, i) => {
          if (fill >= 1) {
            return <FullStar key={i} />
          }
          if (fill >= precision) {
            return <HalfStar key={i} />
          }
          return <EmptyStar key={i} />
        })}
      </div>
      <ShowOnHover>
        <DotIcon />
      </ShowOnHover>
      <ShowOnHover>
        <Review type="primary" data-testid="review-count">
          {i18n.t(`${TRANSLATION}.card.reviews`, { count: rating.toFixed(1) || 0 })}
        </Review>
      </ShowOnHover>
      <HideOnHover>
        <Review type="default" data-testid="review-count">
          {i18n.t(`${TRANSLATION}.card.reviews`, { count: rating.toFixed(1) || 0 })}
        </Review>
      </HideOnHover>
    </Rating>
  )
}
